export function waveSettings(level:number){
 const n=Math.max(1,Math.floor(level));
 return {columns:Math.min(9,6+Math.floor(n/3)),rows:Math.min(5,2+Math.floor(n/3)),speed:Math.min(150,27+n*6),fireInterval:Math.max(.22,1.4-n*.065),shotSpeed:Math.min(330,145+n*9),armor:Math.min(3,1+Math.floor(n/6)),boss:n%5===0};
}
